import * as React from "react"
import {batch} from "@preact/signals-react";

import { CommonFilters } from "@components"
import {customerSelectedID, isLoadingCommonFilters, isSystemBusy} from "@signals";
import {BACKEND_APIS} from "@constants";
import {isEmpty} from "./@signals";


export default function ManagementKeywordsCrudFilters() {

    return <CommonFilters
        components={{
            country: true, site: true,
            keyword: true, customer: true
        }}
        compProps={{
            customer: { grid: { md: 3, xs: 3 } },
            country: {
                grid: { md: 3, xs: 3 },
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/site/market-customer-options`,
                filters: { customerID: customerSelectedID.value }
            },
            site: {
                grid: { md: 3, xs: 3 },
                urlAjax: `${BACKEND_APIS.MASTER_DATA}/site/customer-options`,
                filters: { customerID: customerSelectedID.value }
            },
            keyword: { grid: { md: 3, xs: 3 }, urlAjax: `${BACKEND_APIS.MANAGEMENT}/keywords/keyword-options` },
        }}
        onSubmit={() => {
            batch(() => {
                isEmpty.value = false
                isSystemBusy.value = false
                isLoadingCommonFilters.value = true
            })
        }}
    />
}